import { useTranslation } from "react-i18next";
import { ToggleButton, ToggleButtonGroup } from "@/src/common/components/ui/toggle-button-group";
import { LANGUAGES, type Language } from "@/src/common/locales/i18n";

const LANGS: readonly {
	id: Language;
	labelKey: "top_bar.language.en" | "top_bar.language.es";
}[] = [
	{ id: "en", labelKey: "top_bar.language.en" },
	{ id: "es", labelKey: "top_bar.language.es" },
];

function resolveLanguage(raw: string | undefined): Language {
	if (!raw) return "en";
	const base = raw.toLowerCase().split("-")[0];
	return base in LANGUAGES ? (base as Language) : "en";
}

export function LanguageSwitcher() {
	const { t, i18n } = useTranslation("common");
	const current = resolveLanguage(i18n.language);

	return (
		<div className="flex flex-col gap-1.5 px-3 py-2">
			<span className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">{t("top_bar.language.label")}</span>
			<ToggleButtonGroup
				fullWidth
				size="sm"
				selectionMode="single"
				disallowEmptySelection
				selectedKeys={new Set([current])}
				onSelectionChange={(keys) => {
					const next = [...keys][0] as Language | undefined;
					if (next && next !== current) void i18n.changeLanguage(next);
				}}
			>
				{LANGS.map((lang) => (
					<ToggleButton key={lang.id} id={lang.id} aria-label={t(lang.labelKey)}>
						<ToggleButtonGroup.Separator />
						<span className="text-xs">{t(lang.labelKey)}</span>
					</ToggleButton>
				))}
			</ToggleButtonGroup>
		</div>
	);
}
